import { ABExplorationKeyWords } from "@src/constant/ab-testing/ab-testing-exploration.enum";
import { getColorSignificant, VariantReportToolTip } from "../tooltip-significant";
import { BaseReport } from "../metric-performance/component/metric-performance-item/report-data-v2/variant-report";
import { SpotLightEnum } from "@src/pages/ab-test-explore/enum";

export const RetentionCellRender: React.FC<{
    reportSpotLight?: SpotLightEnum;
    significantInfo?: Record<string, any>;
    exp_value: string;
    significanceLevel: number;
    getExpAliasById: (expId: string) => string;
    isBaseVariant: boolean;
    measureType: string;
}> = ({
    significantInfo,
    exp_value,
    significanceLevel,
    getExpAliasById,
    isBaseVariant,
    reportSpotLight,
    measureType,
}) => {
    const hasSignificant = !!significantInfo;

    if (!hasSignificant) {
        return <div className={`custom-cell bg-neutral-100 text-slate-900 h-[50px] flex items-center`}>-</div>;
    }

    const {
        method,
        p_value,
        mean: mean_variant,
        uplift_percent,
        lower_bound_uplift_percent,
        upper_bound_uplift_percent,
        error_message,
        [ABExplorationKeyWords.SAMPLE_SIZE]: sampleSize,
    } = significantInfo;
    const { bg, upliftPercentTextColor } = getColorSignificant({
        significanceLevel: significanceLevel,
        pValue: p_value,
        upliftPercent: uplift_percent,
    });
    if (isBaseVariant) {
        return (
            <div className="custom-cell">
                <BaseReport
                    reportSpotLight={reportSpotLight}
                    measureType={measureType}
                    mean={mean_variant}
                    pValue={p_value}
                    upliftPercent={uplift_percent}
                    sampleSize={sampleSize}
                    colorFn={() => ({
                        bg,
                        upliftPercentTextColor,
                    })}
                />
            </div>
        );
    }
    return (
        <VariantReportToolTip
            groupAlias={getExpAliasById(exp_value)}
            report={{
                method,
                p_value,
                mean: mean_variant,
                uplift_percent,
                lower_bound_uplift_percent,
                upper_bound_uplift_percent,
                error_message,
                [ABExplorationKeyWords.SAMPLE_SIZE]: sampleSize,
            }}
            significanceLevel={significanceLevel}
        >
            <div className="custom-cell">
                <BaseReport
                    reportSpotLight={reportSpotLight}
                    measureType={measureType}
                    mean={mean_variant}
                    pValue={p_value}
                    upliftPercent={uplift_percent}
                    sampleSize={sampleSize}
                    colorFn={() => ({
                        bg,
                        upliftPercentTextColor,
                    })}
                />
            </div>
        </VariantReportToolTip>
    );
};
